var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 4.834a7.075 7.075 0 0 1-1.967.533 3.441 3.441 0 0 0 1.508-1.892 6.84 6.84 0 0 1-2.175.834 3.416 3.416 0 0 0-5.833 3.116A9.7 9.7 0 0 1 2.824 3.85c-.3.525-.458 1.12-.458 1.725a3.408 3.408 0 0 0 1.517 2.842 3.375 3.375 0 0 1-1.55-.425v.042a3.416 3.416 0 0 0 2.75 3.333c-.298.09-.606.138-.917.141a4.084 4.084 0 0 1-.642-.058 3.425 3.425 0 0 0 3.192 2.367 6.85 6.85 0 0 1-5.05 1.416 9.642 9.642 0 0 0 5.242 1.542 9.659 9.659 0 0 0 9.758-9.733V6.6a7.026 7.026 0 0 0 1.667-1.766Z",
    fill: "currentColor"
  })));
};
export default SvgTwitter;